export default __webpack_public_path__ + "static/media/image.concon-solutions.c2f9ae6f.png";